<script>
	import { query } from "sinao-corejs";
	import { mapGetters, mapState } from "vuex";
    import i18n from "@/i18n";

	export default {
		components: { },
		data() {
			return {
                description: "",
                loaderAi: false,
			};
		},
		computed: {
			...mapState({
				app: state => state.app,
				appId: state => state.app.id,
				models: state => state.models.models,
				table: state => state.billing.table,
				title: state => state.home.title
			}),
			...mapGetters(["enabledHeadersValues", "getModelIndexById"]),
		},
		watch: { },
		methods: {
			async generateEstimate() {
                this.loaderAi = true;

				try {
					const response = await query({
						operationId: "app.openai.billings.estimate",
						params: {
							appId: this.appId,
                            description: i18n.t("Donne-moi un chiffrage détaillé en respectant les instructions données pour ") + this.description + " " + i18n.t("Langue") + " : " + this.$i18n.locale,
						},
						data: { }
					});

                    let lastSectionNumber = this.table.sections.length - 1;
                    let lastEntryNumber = this.table.sections[lastSectionNumber].length - 1;

                    response.lines.forEach(line => {
                        let row = {
                            component: "entry",
                            data: {
                                action: "sell",
                                amount: line.price,
                                designation: line.detail,
                                quantity: line.quantity,
                                unity: line.unity,
                            },
                            key: "entry" + Math.floor(Math.random() * 9999) + 1,
                        };
                        
                        this.table.sections[lastSectionNumber].splice(lastEntryNumber, 0,row);
                    });
                    
                    this.loaderAi = false;

                    this.$store.commit("table", this.table);
                    this.$store.commit("title", response.title);
				} catch (error) {
                    this.loaderAi = false;
					console.error(error);
				}
			},
		}
	};
</script>

<template>
	<div>
		<p class="preamble-openai"> 
            {{ $t("Donne-moi un exemple de chiffrage pour ...") }}
        </p>
        <textarea
            v-model="description"
            class="prompt-openai"
            name=""
            cols="30"
            rows="10"
            :placeholder="$t('... décrire votre projet')"
        />

        <b-button size="sm" class="sinao-button-default" block variant="light" :disabled="description.length < 10 || loaderAi" @click="generateEstimate()">
            <span
                v-if="!loaderAi"
                class="mx-auto"
            > {{ $t("Générer un exemple") }} </span>

            <div 
                v-else 
                class="loader-openai"
            >
                <b-spinner
                    class="spinner"
                    small
                    variant="dark"
                    label="Spinning"
                /> 
                {{ $t("Génération en cours...") }}
            </div>
        </b-button>
	</div>
</template>

<style lang="scss">
	.preamble-openai {
        font-size: 12px;
        color: var(--black);
        font-weight: 500;
        margin: 0;
        margin-bottom: 10px;
    }

    .prompt-openai {
        height: 120px;
        max-width: 100%;
        padding: 10px;
        border: 1px solid var(--border);
        border-radius: 10px;
        font-size: 12px;
        resize: none;

        &:focus,
        &:focus-visible,
        &:focus-within {
            border-color: var(--black) !important;
        }
    }

    .btn-openai {
        background: var(--border);
        // box-shadow: 0px 2px 3px rgba(42, 56, 49, 0.16);
        border-radius: 6px;
        padding: 6px 5px;
        color: var(--white);
        font-size: 13px;
        font-weight: 600;
    }

    .loader-openai {
        margin: auto;
        font-size: 12px;
        font-weight: normal;

        .spinner {
            margin-right: 5px;
        }
    }
</style>
